import { useEffect, useState } from "react";
import { Box, Interpolation } from "@gocardless/flux-react";

import { IBPAnimation } from "./IBPAnimation";
import { DirectDebitAnimation } from "./DirectDebitAnimation";

export enum PaymentType {
  DIRECT_DEBIT = "direct_debit",
  IBP = "ibp",
}

const ANIMATION_START_DELAY = 1000;

export interface TransactionBoxProps {
  restartAnimation: boolean;
  animationRunningOn: string;
  setRestartAnimation: Function;
  setAnimationRunningOn: Function;
}

export const IBPPromoTransactionAnimation: React.FC = () => {
  const [restartAnimation, setRestartAnimation] = useState(false);
  const [animationRunningOn, setAnimationRunningOn] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setAnimationRunningOn(PaymentType.IBP);
    }, ANIMATION_START_DELAY);
  }, []);

  const promotionTransactionStyle: Interpolation = {
    marginTop: "100px",
    position: "absolute",
  };

  return (
    <Box css={promotionTransactionStyle}>
      <IBPAnimation
        restartAnimation={restartAnimation}
        animationRunningOn={animationRunningOn}
        setRestartAnimation={setRestartAnimation}
        setAnimationRunningOn={setAnimationRunningOn}
      />
      <DirectDebitAnimation
        restartAnimation={restartAnimation}
        animationRunningOn={animationRunningOn}
        setRestartAnimation={setRestartAnimation}
        setAnimationRunningOn={setAnimationRunningOn}
      />
    </Box>
  );
};
